/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `ALUMINIUM` - Aluminium
* `PET` - PET
* `HDPE` - HDPE
 */
export type CategoryMaterialType = typeof CategoryMaterialType[keyof typeof CategoryMaterialType];


export const CategoryMaterialType = {
  ALUMINIUM: 'ALUMINIUM',
  PET: 'PET',
  HDPE: 'HDPE',
} as const;
